//#region imports
import React, { useState } from 'react';
import { MENU_ITEMS, RULE_URLS } from 'configs/constants';
import useMobile from 'hooks/useMobile';

import Header from './components/Header';
import About from './components/About';
import Promo from './components/Promo';
import PrizeFond from './components/PrizeFond';
import Winners from './components/Winners';
import Footer from './components/Footer';
import OperatorSlider from './components/OperatorSlider';
import OperatorTabPanel from './components/OperatorTabPanel';
import styles from './styles';
//#endregion

interface IProps {
  onSubscribeClick: () => void;
}

const Main: React.FC<IProps> = ({ onSubscribeClick }) => {

  const classes = styles();
  const { isMobile } = useMobile();
  const [currentLottery, setCurrentLottery] = useState<number>(0);
  const onChangeOperator = (value: number) => setCurrentLottery(value);

  const menuItems = MENU_ITEMS(onSubscribeClick, RULE_URLS[currentLottery]);

  return (
    <div className={ classes.root }>
      <Header items={ menuItems }/>
      <main>
        <Promo onSubscribe={ onSubscribeClick }/>
        { isMobile
          ? <OperatorSlider onChangeNumber={ onChangeOperator } currentNumber={ currentLottery }/>
          : <OperatorTabPanel onChangeNumber={ onChangeOperator } currentNumber={ currentLottery }/>
        }
        <About onSubscribe={ onSubscribeClick } currentNumber={ currentLottery } />
        <PrizeFond currentNumber={ currentLottery } />
        <Winners onSubscribe={ onSubscribeClick }/>
      </main>
      <Footer />
    </div>
  );
};

export default Main;
